<template>
  <div
    style="display:flex;flex-direction: column;align-items: center;padding-top: 40px;"
  >
    <div>
      <span style="font-size: 50px;padding-bottom:10px" class="pink--text"
        >404</span
      >
    </div>
    <p class="text-xs-center justify-center f_18">{{ message }}</p>
    <v-flex>
      <v-btn flat color="primary" @click="$router.back()">
        <v-icon class="pink--text">reply</v-icon>
        <span>GO Back</span>
      </v-btn>
    </v-flex>
  </div>
</template>
<script>
export default {
  props: {
    message: {
      type: String,
      default: "OOPS, Can't Find route"
    }
  }
};
</script>
